export const FIELDS = {
  FORM_HEADING: {
    NAME: 'formHeading',
    TITLE: 'Information Notice',
  },
  NOTICE: {
    NAME: 'informationNoticeAccepted',
    TITLE: 'Social Geographic History',
    CONTENT:
      'I consent to the collection, use and disclosure of my personal and health information as described above.\nI consent to GenesisCare requesting and obtaining my health information from other healthcare providers involved in my care (including hospitals, GPs, specialists, pathology and imaging providers) where reasonably necessary for my treatment.\nBy selecting the checkbox and submitting the form, I acknowledge that I am providing my consent electronically.',
  },
};
